<div class="confirmation-dialog-container">
  <h3 mat-dialog-title class="aza-pa-dialog-title">{{data.title}}</h3>
  <div mat-dialog-content class="aza-pa-dialog-content">
    <azavista-selected-items-count [data]="data.selectedItemsData"></azavista-selected-items-count>
    @for (line of data.contentLines; track line) {
      <p>
        {{line}}
      </p>
    }
  </div>
  <div mat-dialog-actions class="aza-pa-dialog-actions">
    @if (!data.hideCancelButton) {
      <azavista-flat-button action="cancel" (click)="onCancelClick()" class="aza-pa-dialog-action-cancel-button"
        color="primary">
        @if (data.cancelButtonText) {
          <span>{{data.cancelButtonText}}</span>
        }
        @if (!data.cancelButtonText) {
          <span>{{"CANCEL" | translate }}</span>
        }
      </azavista-flat-button>
    }
    <azavista-button action="ok" (click)="onOkClick()" color="primary" class="aza-pa-dialog-action-apply-button">
      @if (data.okButtonText) {
        <span>{{data.okButtonText}}</span>
      }
      @if (!data.okButtonText) {
        <span>{{"OK" | translate }}</span>
      }
    </azavista-button>
  </div>
</div>
